import { Component, Input, OnInit } from '@angular/core';
import { BaseViewComponent, DesignBlockScope, DialogEvents, DialogManager, SimpleDialogData, WebsiteBlockAction, WebsiteBlockImageAction, WebsiteMode, WebsitePageScope, photoGalleryCarouselMaxItems } from '@sb/library/base';
import { WebsiteBlockDisplayItem, WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';
import { DialogDeleteComponent } from '@sb/library/dialog';

@Component({
    selector: 'lib-design-blocks-action-menu',
    templateUrl: './design-blocks-action-menu.component.html',
    styleUrls: ['./design-blocks-action-menu.component.scss']
})
export class DesignBlocksActionMenuComponent extends BaseViewComponent implements OnInit {

    Scope = this.SetScope({
        Requires: [DesignBlockScope, WebsitePageScope]
    });

    @Input() showEditBadgeError: boolean = false;

    private _showActionMenu!: boolean;
    private _showImageActions: boolean = false;
    private _isCarousel: boolean = false;
    private _showEdit: boolean = false;

    constructor(private _DialogManager: DialogManager) {
        super();
    }

    override ngOnInit() {
        super.ngOnInit();

        this._showActionMenu = !this.isDesktop;
        if (WebsiteBlockDisplayItem.IsTextAndMedia(this.Scope.websiteBlockData)) {
            this._isCarousel = this.Scope.websiteBlockData.TextAndMediaType === WebsiteBlockTextAndMediaType.PhotoGalleryCarousel
                            || this.Scope.websiteBlockData.TextAndMediaType === WebsiteBlockTextAndMediaType.PhotoGalleryCarouselOverlay;

            this._showImageActions = this._isCarousel || WebsiteBlockTextAndMediaDisplayItem.IsGalleryBlock(this.Scope.websiteBlockData);
            this._showEdit = WebsiteBlockTextAndMediaDisplayItem.IsCallToActionBlock(this.Scope.websiteBlockData)
                          || WebsiteBlockTextAndMediaDisplayItem.IsHTMLBlock(this.Scope.websiteBlockData);
        } else {
            this._showEdit = WebsiteBlockDisplayItem.IsContactForm(this.Scope.websiteBlockData)
                          || WebsiteBlockDisplayItem.IsEmbed(this.Scope.websiteBlockData)
                          || WebsiteBlockDisplayItem.IsSignupForm(this.Scope.websiteBlockData)
                          || WebsiteBlockDisplayItem.IsReviews(this.Scope.websiteBlockData) && this.Scope.renderContext.SchoolIsMultiTeacher;
        }
    }

    MouseEntered(): void {
        if (this.isDesktop) {
            this._showActionMenu = true;
        }
    }

    MouseLeave() {
        if (this.isDesktop) {
            this._showActionMenu = false;
        }
    }

    MediaGalleryClicked(): void {
        this.Scope.HandleBlockAction(this.Scope.websiteBlockData, WebsiteBlockAction.MediaGallery);
    }

    AddClicked(): void {
        const galleryBlock = WebsiteBlockDisplayItem.AsTextAndMedia(this.Scope.websiteBlockData);
        this.Scope.HandleImageAction(galleryBlock, WebsiteBlockImageAction.Add, galleryBlock.Images.length);
    }

    RemoveClicked(): void {
        const galleryBlock = WebsiteBlockDisplayItem.AsTextAndMedia(this.Scope.websiteBlockData);
        this.Scope.HandleImageAction(galleryBlock, WebsiteBlockImageAction.Delete, galleryBlock.Images.length - 1);
    }

    MoveUpClicked(): void {
        this.Scope.HandleBlockAction(this.Scope.websiteBlockData, WebsiteBlockAction.MoveUp);
    }

    MoveDownClicked(): void {
        this.Scope.HandleBlockAction(this.Scope.websiteBlockData, WebsiteBlockAction.MoveDown);
    }

    EditClicked(): void {
        this.Scope.HandleBlockAction(this.Scope.websiteBlockData, WebsiteBlockAction.Edit);
    }

    CopyClicked(): void {
        this.Scope.HandleBlockAction(this.Scope.websiteBlockData, WebsiteBlockAction.Copy);
    }

    DeleteClicked(): void {
        this.CreateDialog(DialogDeleteComponent, new SimpleDialogData({
            Title: $localize`:@@CommonDesignBlockActionMenuDeleteBlockTitle:Delete Block`,
            Text: $localize`:@@CommonDesignBlockActionMenuDeleteBlockText:Are you sure you want to delete this block?`,
        })).events.subscribe(event => {
            switch (event) {
                case DialogEvents.PrimaryAction:
                    this._DialogManager.DismissDialog();
                    this.Scope.HandleBlockAction(this.Scope.websiteBlockData, WebsiteBlockAction.Delete);
                    break;
            }
        });
    }

    get showActionMenu(): boolean {
        return this._showActionMenu && this.Scope.websiteMode === WebsiteMode.Preview;
    }

    get showImageActions(): boolean {
        return this._showImageActions;
    }

    get showEdit(): boolean {
        return this._showEdit;
    }

    get disableAddImage(): boolean {
        return this._isCarousel && (this.Scope.websiteBlockData as WebsiteBlockTextAndMediaDisplayItem).Images.length >= photoGalleryCarouselMaxItems;
    }

    get disableRemoveImage(): boolean {
        return (this.Scope.websiteBlockData as WebsiteBlockTextAndMediaDisplayItem).Images.length <= (this._isCarousel ? 3 : 1);
    }

    get WebsiteBlockAction(): typeof WebsiteBlockAction {
        return WebsiteBlockAction;
    }
}
